import React from 'react'
import { Header, TableComplete } from '@e3dc-react/shell/Elements/Table'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { nullsLast } from '@e3dc-react/shell/Libs/SortAlgorithms'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import { BatteryPowerManagementModel } from 'src/Libs/batteries/models/battery.model'
import List from '@e3dc-react/shell/Elements/List/List'

type BatteryPowerManagementProps = {
  bpm: BatteryPowerManagementModel[]
}

/**
 * Component that holds a table with battery power management values of a storage
 */
const BatteryPowerManagementTable: React.FC<BatteryPowerManagementProps> = ({ bpm }) => {
  const { t } = useCustomTranslation()
  const theme = useTheme()
  const showListView = useMediaQuery(theme.breakpoints.down('sm'))

  const bpmHeaders: Header<BatteryPowerManagementModel>[] = [
    {
      value: 'tcManufacurerName',
      label: t('system-details.components.bpm.tcManufacurerName'),
      isSortable: true,
      sortFunction: nullsLast((a: number, b: number) => a - b),
      valueRender: value => value ?? '-',
    },
    {
      value: 'tcDeviceName',
      label: t('system-details.components.bpm.tcDeviceName'),
      isSortable: true,
      sortFunction: nullsLast((a: number, b: number) => a - b),
      valueRender: value => value ?? '-',
    },
    {
      value: 'iFWVersion',
      label: t('system-details.components.bpm.iFWVersion'),
      sortFunction: nullsLast((a: string, b: string) => a.localeCompare(b)),
      valueRender: value => value ?? '-',
    },
  ]

  if (showListView) {
    return (
      <Box sx={theme => ({ paddingBottom: theme.spacing(2) })}>
        <List
          data={bpm.map(item => ({
            primary: item.iSerialNumber,
            secondary: item.tcDeviceName,
          }))}
          noDataText={t('system-details.components.bpm.no-data')}
        />
      </Box>
    )
  }

  return (
    <TableComplete
      header={bpmHeaders}
      data={bpm ?? []}
      headerElevation={0}
      bodyElevation={0}
      footerElevation={0}
      coloredColumn
      disablePagination
      noDataText={t('system-details.components.bpm.no-data')}
    />
  )
}

export default BatteryPowerManagementTable
